import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import CustomSegment from '../../../../components/CustomSegment';
import PaymentModal from '../../../../components/PaymentModal';
import MODULES from '../../../../config/modules.config';
import useModal from '../../../../hooks/useModal';
import { useSegment } from '../../../../hooks/useSegment';
import DashboardLayout from '../../../../layouts/DashboardLayout';
import type { SegmentedType } from '../../../../types/global.types';
import EmployeeDirectory from './EmployeeDirectory';
import ManagementDashboard from './ManagementDashboard';
import Subscriptions from './Subscriptions';
import Summery from './Summery';
import { useAppDiscloser } from '@/hooks';
import CreateEmployee from './CreateEmployee';

type SegmentType =
  | 'management-dashboard'
  | 'summery'
  | 'departments'
  | 'directory'
  | 'subscriptions';

const EmpDashboard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const current = searchParams.get('segment');
  const success = searchParams.get('success');
  const { open, handleOpen, handleClose } = useModal<undefined, 'SUCCESS'>(
    reRender,
  );

  const { segment, setSegment } = useSegment<SegmentType>(
    'summery',
    'summery',
    false,
  );

  const [createEmployeeConfig, , handleCreateEmployeeClose] = useAppDiscloser(
    'CREATE_EMPLOYEE',
  );
  const SEGMENT_CONFIG: SegmentedType<SegmentType>[] = [
    {
      value: 'summery',
      label: 'Summary',
      view: <Summery />,
    },
    {
      moduleId: MODULES.ADMIN_MANAGEMENT_DASHBOARD,
      value: 'management-dashboard',
      label: 'Management Dashboard',
      view: <ManagementDashboard />,
    },
    {
      value: 'directory',
      label: 'Employee Directory',
      view: <EmployeeDirectory />,
    },
    {
      value: 'subscriptions',
      label: 'Subscriptions',
      view: <Subscriptions />,
    },
  ];
  const currentSegment = SEGMENT_CONFIG.find((s) => s.value === segment);

  useEffect(() => {
    if (current) {
      setSegment(current as SegmentType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (success === 'true') {
      handleOpen({ type: 'SUCCESS' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  function reRender() {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete('success');
    setSearchParams(newParams, { replace: true });
  }

  return (
    <DashboardLayout title="Dashboard">
      {open?.type === 'SUCCESS' && (
        <PaymentModal
          open={open?.open}
          type="SUCCESS"
          handleClose={handleClose}
        />
      )}
      <CustomSegment
        config={SEGMENT_CONFIG}
        selected={segment}
        onChange={setSegment}
      />
      <div className="mt-5">{currentSegment?.view}</div>

      <CreateEmployee
        data={createEmployeeConfig.data}
        open={createEmployeeConfig.open}
        handleClose={handleCreateEmployeeClose}
        type={createEmployeeConfig.type}
      />
    </DashboardLayout>
  );
};

export default EmpDashboard;
